import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { baseURL } from '../../config';
import { openNotification } from '../../components/common/helper';

const initialState = {
    isLoading: false,
    isSnapshotLoading: false,
    error: null,
    claims: [],
    property: {},
    claimDetails: { isLoading: false, claim: null },
    snapshot: {},
    claim_type: localStorage.getItem('claimType') || 'Hospital',
    status_filter: localStorage.getItem('statusFilter') || 'Pending',
    visit_filter: localStorage.getItem('visitFilter') || 'All'
};


export const listClaims = createAsyncThunk('claims/List', async ({ size, page, source, visitType, status, sort }, thunkAPI) => {
    //    return await fetch(source === 'Reimbursement_Claims' ?
    //      `${baseURL}reimbursed-claim?size=${size}&page=${page}${(status && (status !== 'All')) ? ('&status=' + status) : ''}&sort=createdTimestamp,${sort}`
    //    : `${baseURL}claims/list?size=${size}&page=${page}${source ? `&type=${source}` : ''}${(status && (status !== 'All')) ? ('&status=' + status) : ''}${(visitType && (visitType !== 'All')) ? ('&visitType=' + visitType) : ''}&sort=createdTimestamp,${sort}`, {
    //    return await fetch(`${baseURL}claims?pageSize=${size}&page=${page}${source ? `&type=${source}` : ''}${(status && (status !== 'All')) ? ('&status=' + status) : ''}${(visitType && (source !== 'Mental_Health') && (visitType !== 'All')) ? ('&visitType=' + visitType) : ''}&sortOrder=${sort}`, {

    return await fetch(source === 'Reimbursement_Claims' ?
        `${baseURL}reimbursed-claim?size=${size}&page=${page}${(status && (status !== 'All')) ? ('&status=' + status) : ''}&sort=createdTimestamp,${sort}`
        : `${baseURL}claims?pageSize=${size}&page=${page}${source ? `&type=${source}` : ''}${(status && (status !== 'All')) ? ('&status=' + status) : ''}${(visitType && (source !== 'Mental_Health') && (visitType !== 'All')) ? ('&visitType=' + visitType) : ''}&sortOrder=${sort}`, {

        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(async res => {
            return res.json().then(resJson => {
                if (!res.ok) throw new Error(resJson?.error)
                return resJson
            })
        })
        .catch(e => thunkAPI.rejectWithValue(e.message))
});


export const searchClaims = createAsyncThunk('claims/Search', async ({ query, size, page }, thunkAPI) => {
    return await fetch(`${baseURL}pas/claim/search?query=${query}&size=${size}&page=${page}`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(async res => {
            return res.json().then(resJson => {
                if (!res.ok) throw new Error(resJson?.error)
                return resJson
            })
        })
        .catch(e => thunkAPI.rejectWithValue(e.message))
});

export const listPharmacyClaims = createAsyncThunk('claims/ListPharmacy', async ({ size, page }, thunkAPI) => {
    return await fetch(`${baseURL}pas/claim/pharmacy/list?size=${size}&page=${page}`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(async res => {
            return res.json().then(resJson => {
                if (!res.ok) throw new Error(resJson?.error)
                return resJson
            })
        })
        .catch(e => thunkAPI.rejectWithValue(e.message))
});

export const getClaimDetails = createAsyncThunk('claims/getClaim', async ({ claim_id, source }, thunkAPI) => {
    return await fetch(source === 'Reimbursement_Claims' ? `${baseURL}reimbursed-claim/${claim_id}/details?benefits=true`
        : `${baseURL}claims/${claim_id}/details`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(async res => {
            return res.json().then(resJson => {
                if (!res.ok) throw new Error(resJson?.error)
                return resJson
            })
        })
        .catch(e => thunkAPI.rejectWithValue(e.message))
});

export const getClaimSnapshot = createAsyncThunk('claims/getSnapshot', async (args, thunkAPI) => {
    return await fetch(`${baseURL}claims/stats`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('token')
        }
    })
        .then(async res => {
            return res.json().then(resJson => {
                if (!res.ok) throw new Error(resJson?.error)
                return resJson
            })
        })
        .catch(e => thunkAPI.rejectWithValue(e.message))
});


export const ClaimSlice = createSlice({
    name: 'claims',
    initialState: initialState,
    reducers: {
        logOut: (state, actions) => {
            state.isLoading = false;
            state.isAuthenticated = false;
            state.token = null;
            localStorage.clear();
        },
        clearErr: (state, actions) => {
            state.error = null;
        },
        setClaimType: (state, action) => {
            state.claim_type = action.payload
            localStorage.setItem('claimType', action.payload)
        },
        setStatusFilter: (state, action) => {
            console.log('in here')
            state.status_filter = action.payload
            localStorage.setItem('statusFilter', action.payload)
        },
        setVisitFilter: (state, action) => {
            state.visit_filter = action.payload
            localStorage.setItem('visitFilter', action.payload)
        },
    },
    extraReducers(builder) {
        builder.addCase(listClaims.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(listClaims.fulfilled, (state, action) => {
            state.claims = action.payload.result?.content
            state.property.total_elements = action.payload.result?.total_elements
            state.isLoading = false;
        });
        builder.addCase(listClaims.rejected, (state, action) => {
            openNotification(action.payload, 'Error')
            state.isLoading = false;
        });
        builder.addCase(searchClaims.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(searchClaims.fulfilled, (state, action) => {
            state.claims = action.payload.result.content
            state.property.total_elements = action.payload.result?.total_elements
            state.isLoading = false;
        });
        builder.addCase(searchClaims.rejected, (state, action) => {
            openNotification(action.payload, 'Error')
            state.isLoading = false;
        });
        builder.addCase(listPharmacyClaims.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(listPharmacyClaims.fulfilled, (state, action) => {
            state.claims = action.payload.result.content
            state.property.total_elements = action.payload.result?.total_elements
            state.isLoading = false;
        });
        builder.addCase(listPharmacyClaims.rejected, (state, action) => {
            openNotification(action.payload, 'Error')
            state.isLoading = false;
        });
        builder.addCase(getClaimDetails.pending, (state) => {
            state.claimDetails.isLoading = true;
        });
        builder.addCase(getClaimDetails.fulfilled, (state, action) => {
            state.claimDetails.claim = action.payload.result
            state.claimDetails.isLoading = false;
        });
        builder.addCase(getClaimDetails.rejected, (state, action) => {
            openNotification(action.payload, 'Error')
            state.claimDetails.isLoading = false;
        });
        builder.addCase(getClaimSnapshot.pending, (state) => {
            state.isSnapshotLoading = true;
        });
        builder.addCase(getClaimSnapshot.fulfilled, (state, action) => {
            // state.claims = action.payload.result.content
            state.snapshot = action.payload.result
            state.isSnapshotLoading = false;
        });
        builder.addCase(getClaimSnapshot.rejected, (state, action) => {
            openNotification(action.payload, 'Error')
            state.isSnapshotLoading = false;
        });
    },
});
export const { clearErr, setClaimType, setStatusFilter, setVisitFilter } = ClaimSlice.actions
export default ClaimSlice.reducer;